module.exports = __webpack_public_path__ + "static/media/ps.72a58ce1.svg";